<div class="chatbot-wrapper">
  <div
    class="chat-panel"
    [class.open]="isOpen"
    [style.width.px]="panelWidth"
    [style.height.px]="panelHeight"
  >
    <button
      type="button"
      class="resize-handle"
      aria-label="Resize chat"
      (pointerdown)="startResize($event)"
    ></button>
    <div class="chat-header">
      <div class="flex items-center gap-3">
        <div class="chat-avatar">
          <img src="assets/images/ask-roar-open.png" alt="" />
        </div>
        <div>
          <p class="chat-title">ASK ROAR</p>
          <p class="chat-status">{{ isSessionLoading ? 'Connecting...' : 'Online' }}</p>
        </div>
      </div>
      <button mat-icon-button (click)="toggleChat()" aria-label="Close chat">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="chat-messages" #messagesContainer>
      <div
        *ngFor="let msg of messages"
        class="message-row"
        [class.user]="msg.sender === 'user'"
        [class.bot]="msg.sender === 'bot'"
      >
        <div *ngIf="msg.sender === 'user'" class="message-bubble">
          {{ msg.text }}
        </div>
        <div
          *ngIf="msg.sender === 'bot'"
          class="message-bubble markdown"
          [innerHTML]="msg.html"
        ></div>
      </div>

      <div *ngIf="isSessionLoading" class="message-row bot">
        <div class="message-bubble typing">
          <span></span><span></span><span></span>
        </div>
      </div>

      <div *ngIf="isTyping" class="message-row bot">
        <div class="message-bubble typing">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <div class="chat-input">
      <input
        type="text"
        [(ngModel)]="userInput"
        (keydown)="onKeydown($event)"
        placeholder="Type a message..."
        [disabled]="isTyping || isSessionLoading"
      />
      <button
        mat-icon-button
        color="primary"
        (click)="sendMessage()"
        [disabled]="!userInput.trim() || isTyping || isSessionLoading"
        aria-label="Send message"
      >
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>

  <button
    type="button"
    class="chat-fab"
    (click)="toggleChat()"
    [attr.aria-label]="isOpen ? 'Close chat' : 'Open chat'"
  >
    <img src="assets/images/ask-roar.png" alt="" />
  </button>
</div>
